import * as React from 'react';

import type { SelectRootValues } from './useSelectRoot';

export const SelectRootContext = React.createContext<SelectRootValues | null>(null);

SelectRootContext.displayName = 'SelectRootContext';

export function useSelectRootContext() {
    const context = React.useContext(SelectRootContext);
    if (context === null) {
        throw new Error('useSelectRootContext must be used within a SelectRootContext provider.');
    }
    return context;
}
